import { Bar, Pie, Progress } from "@ant-design/plots";
import { ClassYearDistributionData } from "./ClassyearDistribution";
import { StudyProgramDistributionData } from "./StudyProgramDistribution";

interface Props {
  percent: number;
  color: string;
}

export const EventProgress: React.FC<Props> = ({ percent, color }) => {
  return <Progress height={10} autoFit percent={percent} color={[color, "#E8EDF3"]} style={{ borderRadius: "50%" }} />;
};

interface StudyProgramsChartProps {
  studyPrograms: StudyProgramDistributionData[];
}

export const StudyProgramsChart: React.FC<StudyProgramsChartProps> = ({ studyPrograms }) => {
  return (
    <Bar
      data={studyPrograms}
      xField="amount"
      yField="studyProgram"
      seriesField="studyProgram"
      legend={false}
      tooltip={{
        showTitle: false,
        domStyles: {
          "g2-tooltip-list": {
            color: "var(--dark)",
          },
        },
      }}
      maxBarWidth={80}
    />
  );
};

interface ClassYearChartProps {
  classYears: ClassYearDistributionData[];
}

export const ClassyearChart: React.FC<ClassYearChartProps> = ({ classYears }) => {
  return (
    <Pie
      data={classYears}
      angleField="amount"
      colorField="classYear"
      radius={1}
      innerRadius={0.6}
      legend={{
        position: "top",
        flipPage: false,
      }}
      tooltip={{
        domStyles: {
          "g2-tooltip-list": {
            color: "var(--dark)",
          },
        },
      }}
      label={false}
      statistic={{
        title: false,
        content: {
          style: {
            whiteSpace: "pre-wrap",
            overflow: "hidden",
            textOverflow: "ellipsis",
            fontSize: "1.5em",
            color: "var(--font-color)",
          },
          content: "Fordeling\nårstrinn",
        },
      }}
    />
  );
};
